import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row no-gutters irx-grey-background" }
const _hoisted_2 = { class: "col col-12 col-md-10 offset-md-1" }
const _hoisted_3 = { class: "card my-2" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "row no-gutters px-4 py-4 align-items-end" }
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "card" }
const _hoisted_9 = {
  class: "card-body",
  style: {}
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("h1", { class: "text-center h2" }, "Reimburse Me", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[0] || (_cache[0] = _createElementVNode("h2", {
                class: "h1",
                style: {"color":"var(--primary-color)","font-weight":"bold"}
              }, "Medical Insurance Reimbursement Help", -1)),
              _cache[1] || (_cache[1] = _createElementVNode("p", null, " When paying for a prescription out of pocket with IntelligentRx's discount cards, you aren't using your insurance. Sometimes your insurance company will reimburse you for these payments or view the service as out-of-network and apply the payment against your deductible. Either way, applying for reimbursement from your insurance can be well worth the 5 minutes it takes. ", -1)),
              _cache[2] || (_cache[2] = _createElementVNode("p", null, "To apply for reimbursement, follow these steps:", -1)),
              _cache[3] || (_cache[3] = _createElementVNode("ol", null, [
                _createElementVNode("li", null, "Get receipts for the service"),
                _createElementVNode("li", null, "Make copies of your receipts for your own records (pictures with your phone camera may work) "),
                _createElementVNode("li", null, "Fill out a reimbursement form from your health insurer"),
                _createElementVNode("li", null, "Mail or fax the form to your health insurer")
              ], -1)),
              _cache[4] || (_cache[4] = _createElementVNode("p", null, "Contact information for the most common insurers are below", -1)),
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reimbursementInfos, (reimbursement) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "col col-6 col-md-4 pb-3",
                    key: reimbursement.InsurerName
                  }, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("p", null, _toDisplayString(reimbursement.InsurerName), 1),
                        _createElementVNode("p", null, _toDisplayString(reimbursement.AddressRow0), 1),
                        _createElementVNode("p", null, _toDisplayString(reimbursement.AddressRow1), 1),
                        _createElementVNode("p", null, _toDisplayString(reimbursement.AddressRow2), 1),
                        (reimbursement.FaxNumber != null && reimbursement.FaxNumber !== '')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(reimbursement.FaxNumber), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("a", {
                          href: reimbursement.FormLink,
                          class: "btn irx-btn-primary irx-btn-primary-animated w-100 btn-lg"
                        }, _toDisplayString(reimbursement.InsurerName) + " Form", 9, _hoisted_11)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}